import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import {
  CustomTooltipModule,
  NgCommonModule,
} from '@principle-theorem/ng-shared';

@Component({
  selector: 'pr-file-upload-summary',
  templateUrl: './file-upload-summary.component.html',
  styleUrl: './file-upload-summary.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'flex flex-col gap-4' },
  imports: [NgCommonModule, CustomTooltipModule, MatIconModule],
})
export class FileUploadSummaryComponent {}
